import mmyCircleLogo from 'img/lockMMY/mmy_circle_logo.svg';
import mmyToken from 'img/ic_mmy_24.svg'
import icScan from 'img/ic_scan.svg'
import icTime from 'img/lockMMY/timer.svg';
import icArrowSumary from 'img/lockMMY/arrow_down.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import { Switch } from 'antd';
import useSWR from 'swr';
import { useWeb3React } from '@web3-react/core';
import { useChainId } from 'lib/chains';
import { getContract } from 'config/contracts';
import { contractFetcher } from 'lib/contracts';
import { PLACEHOLDER_ACCOUNT } from 'lib/legacy';
import Token from "abis/Token.json";
import { useEffect, useState } from 'react';
import { formatAmount, parseValue } from 'lib/numbers';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import useLockMMYLP from 'hooks/useLockMMYLP';
import { BigNumber, ethers } from 'ethers';
import { approveTokens, secondsToDhms } from 'domain/tokens';
import useUserLockedMMYLP from 'hooks/useUserLockedMMYLP';
import ExtendLockModal from './ExtendLockModal';
const { AddressZero } = ethers.constants;
const MMYLPOverview = ({ setPendingTxns, pendingTxns, connectWallet, userInfo }) => {
  const onChange = async (checked) => {
    const res = await setAutoReLock(checked);
    setToggleAutoLock(checked)
  };
  const [value, setValue] = useState(userInfo?.lockType || 0);
  const [duration, setDuration] = useState(0);
  const [toggleAutoLock, setToggleAutoLock] = useState(userInfo?.autoLock || true);
  const [isApproving, setIsApproving] = useState(false);
  const [isExtendVisible, setIsExtendVisible] = useState(false);
  const [currentLockType, setCurrentLockType] = useState(0)
  const { active, account, library } = useWeb3React()
  const { chainId } = useChainId()
  const mmyLPAddess = getContract(chainId, "MMYLP")
  const FeeDistributionAddress = getContract(chainId, "MultiFeeDistribution");
  const { lockInfo } = userInfo;
  const mmyLPPrice = 1;
  const { data: mmyLPBalance } = useSWR(
    () => [`StakeV2:balanceOfMMY:${active}:${account}`, chainId, mmyLPAddess, "balanceOf"],
    {
      fetcher: contractFetcher(library, Token, [account || PLACEHOLDER_ACCOUNT]),
    }
  );
  const { data: tokenAllowance } = useSWR(
    active && mmyLPAddess && [active, chainId, mmyLPAddess, "allowance", account, FeeDistributionAddress],
    {
      fetcher: contractFetcher(library, Token),
    }
  );

  // useEffect(() => {
  //   if (currentLockType !== userInfo?.lockType)
  //     setCurrentLockType(userInfo?.lockType)
  // }, [userInfo?.lockType])
  // useEffect(() => {
  //   if (toggleAutoLock !== userInfo?.autoLock)
  //     setToggleAutoLock(userInfo?.autoLock)
  // }, [userInfo?.autoLock])

  const onChangLockType = async (lockType) => {
    const res = await setChangeDefaultLockType(lockType);
    setCurrentLockType(lockType);
  }
  const onHandleRelock = async () => {
    await reLock();
  }
  const onHandleWithDraw = async () => {
    await setWithdraw();
  }
  const isDisableRelockAndWithDraw = () => {
    const { totalLockedDone } = userInfo;
    if (!totalLockedDone || (totalLockedDone && totalLockedDone.eq(0))) return true;
    // debugger

    return false;
  }
  const isLocked = false;
  const monthTabs = [
    { type: 0, text: "1 month", apr: 1.447 },
    { type: 1, text: "3 months", apr: 1.447 },
    { type: 2, text: "6 months", apr: 1.447 },
    { type: 3, text: "12 months", apr: 1.447 },
  ]
  let amount = parseValue(value || 0, 18);
  const needApproval = FeeDistributionAddress !== AddressZero && tokenAllowance && amount && (tokenAllowance.eq(0) || amount.gt(tokenAllowance));
  const { setLock, setChangeDefaultLockType, setWithdraw, setAutoReLock, reLock } = useLockMMYLP(setPendingTxns)
  const onHandleLock = async () => {
    await setLock(parseValue(value, 18), currentLockType)
    setValue(0)
  }
  const isDisableLockBtn = () => {
    if (!value || value === 0) return true;
    if (value && parseValue(value, 18).gt(mmyLPBalance || 0)) return true;
    return false;
  }
  // console.log("????", userInfo);
  const relockAmount = userInfo?.totalLockedDone ? userInfo.totalLockedDone : BigNumber.from(0)
  return (
    <div className="lockMMY-info-container overview-lp-container">
      <div className="title">
        <div className='title-main'>
          MMY-LP overview
        </div>
        <ExternalLink className='getLP' href='/#'>
          Get MMY-LP <img src={icScan} alt='' />
        </ExternalLink>
      </div>
      <div className='lockMMY-content-container'>
        {!isLocked &&
          <div className='lock-inside-content'>
            <div className='input-container'>
              <div className='title-container'>
                <div className='title'>Lock</div>
                <div className='max-amount cursor-pointer' onClick={() => setValue(formatAmount(mmyLPBalance || 0, 18, 18, false))}>Max: {formatAmount(mmyLPBalance || 0, 18, 4, true)}</div>
              </div>
              <div className='input-content'>
                <input placeholder='0.0' type='number' value={value} onChange={e => setValue(e.target.value)} />
                <div className='token-info'>
                  <button className='App-button-option btn-max'>Max</button>
                  <img alt='' src={mmyCircleLogo} /> MMY-LP
                </div>
              </div>
            </div>
            <div className='input-container' style={{ marginTop: '8px' }}>
              <div className='title-container'>
                <div className='title'>Lock for</div>
                <div className='max-amount cursor-pointer'>7days - 4years</div>
              </div>
              <div className='input-content'>
                <input placeholder='0.0' type='number' value={duration} onChange={e => setDuration(e.target.value)} />
                <div className='token-info'>
                  <img alt='' src={icTime} /> Days
                </div>
              </div>
            </div>

            <div className='default-lock-container'>
              <div className='months-container'>
                {monthTabs.map(item => (
                  <div
                    onClick={() => onChangLockType(item.type)}
                    key={item.type} className={`month-tab ${currentLockType === item.type ? 'month-tab-active' : ''}`}>{item.text}</div>
                ))}
              </div>
              <div className='arrow-container'>
                <img alt='' src={icArrowSumary} />
              </div>
              <div className='summary-container'>
                <div className='title'>Summary</div>
                <div className='sumary-content'>
                  <div className='title'>Est. current veMMY-LP</div>
                  <div className='value green-value'>100</div>
                </div>
                <div className='sumary-content'>
                  <div className='title'>MMY-LP locked</div>
                  <div className='value'>100</div>
                </div>
                <div className='sumary-content'>
                  <div className='title'>Locked until</div>
                  <div className='value'>02/23/2023 07:00 UTC</div>
                </div>
              </div>
              <div className='action-buttons'>
                {
                  account ? needApproval ? <button className='App-button-option'
                    onClick={() => approveTokens({
                      setIsApproving,
                      library,
                      tokenAddress: mmyLPAddess,
                      spender: FeeDistributionAddress,
                      chainId,
                    })}
                  >Approve</button>
                    : <button className='App-button-option'
                      onClick={onHandleLock}
                      disabled={isDisableLockBtn()}>Lock</button>
                    : <button className='App-button-option' onClick={() => connectWallet()}>Connect Wallet</button>
                }
              </div>
            </div>
          </div>}
        {isLocked &&
          (<div className='locked-container'>
            <div className='locked-line'>
              <div className='lock-title'>MMY-LP locked</div>
              <div className='lock-value'>0</div>
            </div>
            <div className='locked-line'>
              <div className='lock-title'>Locked until</div>
              <div className='lock-value'>0</div>
            </div>
            <div className='locked-line'>
              <div className='lock-title'>veMMY-LP required to unlock</div>
              <div className='lock-value'>0</div>
            </div>
            <div className='locked-line'>
              <div className='lock-title'>veMMY-LP in wallet</div>
              <div className='lock-value'>0</div>
            </div>
            <div className='locked-line'>
              <div className='lock-title'>Early unlock penalty fee</div>
              <div className='lock-value'>075%</div>
            </div>
            {account ? <div className="action-buttons">
              <button className="App-button-option" onClick={() => setIsExtendVisible(true)}>Extend lock</button>
              <button className="App-button-option border-btn">Unstake</button>
            </div> : <div className="action-buttons">
              <button className="App-button-option">Early unlock</button>
            </div>}
          </div>)}

      </div>
      <ExtendLockModal
        visible={isExtendVisible}
        setIsVisible={setIsExtendVisible}
        userInfo={userInfo}
        mmyLPBalance={mmyLPBalance}
        setPendingTxns={setPendingTxns}
        connectWallet={connectWallet}
        tokenAllowance={tokenAllowance}
      />
    </div >
  )
}
export default MMYLPOverview;
